import {Line} from './Line';
import {Header} from './Header';
import {Button} from './Button';
import {TabLoader} from './TabLoader';
import {RatingStars} from './RatingStars';
import {BlockHeading} from './BlockHeading';
import {BurgerMenuItem} from './BurgerMenuItem';
import {ProfileItem} from '../items/ProfileItem';
import {BottomTabBar} from '../navigation/BottomTabBar';
import '../assets/fonts/fonts.css';
import Loading from './Loading';

export const components = {
  Line,
  Header,
  Button,
  Loading,
  TabLoader,
  ProfileItem,
  RatingStars,
  BottomTabBar,
  BlockHeading,
  BurgerMenuItem,
};
